export enum IDPHint {
  GSUITE = 'gsuite',
}
